const tableTitleFrequency = {
  title: 'Periodicidades',
  placeholder: 'Pesquisar',
  Typography: 'Nenhum resultado encontrado'
};

export default tableTitleFrequency;
